import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import logo from '../../images/logo.svg'
import search from '../../images/Search.png'
import safe from '../../images/safe.png'
import Notificationbell from '../../images/Notificationbell.png'
import academiconsAfricarxiv from '../../images/academiconsAfricarxiv.png'
import callcalling1 from '../../images/callcalling1.png'
import palace from '../../images/palace.png'
import tower from '../../images/tower.png'
import calendar from '../../images/calendar-2.png'
import ave from '../../images/ave.svg'
import quote from '../../images/quote.png'
import Footer from '../../images/Footer.png'
import yellowlogo from '../../images/yellowlogo.svg';
import sammy from '../../images/sammy.png'
import Group778 from '../../images/Group778.png'
import Group779 from '../../images/Group779.png'
import Group828 from '../../images/Group828.png'
import princess from '../../images/princess.png'
import Desmond from '../../images/Desmond.png'
import blackquote from '../../images/blackquote.png'

import heart from '../../images/heart.png'
import star1 from '../../images/Star1.png'
import homepage from '../../images/homepage.png'
import pyramid from '../../images/pyramid.png'
import { FiArrowRight } from 'react-icons/fi';
import { FaArrowRight, FaArrowLeft, FaCalendar} from 'react-icons/fa';
import { Container, Navbar, Nav, Button, NavDropdown, Form ,FormControl, Col, Row, Card} from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom'
import './home.css'
import AppNavbar from '../../components/Navbar';
import { CloseButton, Carousel} from 'react-bootstrap';
import Chatbot from 'react-chatbot-kit';

import 'react-chatbot-kit/build/main.css'
import config from '../../chatbot/config';
import ActionProvider from '../../chatbot/ActionProvider';
import MessageParser from '../../chatbot/MessageParser';
import chatIcon from '../../images/chat-icon.svg'



const Home = () => {
  const navigate = useNavigate()
  const [showChat, setShowChat] = useState(false);
  const [validated, setValidated] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedDate2, setSelectedDate2] = useState(null);

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };
  const handleDate2Change = (date) => {
    setSelectedDate2(date);
  };
   const handleSubmit = (event) => {
     const form = event.currentTarget;
     if (form.checkValidity() === false) {
       event.preventDefault();
       event.stopPropagation();
       setValidated(false)
     } else{
 
     setValidated(true);
     navigate('/signup')}
   };
  
   const handleSubscribeSubmit = (event) => {
     const form = event.currentTarget;
     if (form.checkValidity() === false) {
       event.preventDefault();
       event.stopPropagation();
       setValidated(false)
     } else{
 
     setValidated(true);
     navigate('/subscribe')}
   };
  
   
     const toggleChat = () => {
       setShowChat((prevState) => !prevState);
       
   };
   const closeChat = () => {
     setShowChat(false);
 };
 const carouselStyles = {
   '& .carousel-control-prev-icon, & .carousel-control-next-icon': {
     fill: 'black',
   },
 };
 const CustomPrevIcon = ({ onClick }) => (
   <div className="custom-prev-icon" onClick={onClick}>
     <FaArrowLeft/>
   </div>
 );
 
 const CustomNextIcon = ({ onClick }) => (
   <div className="custom-next-icon" onClick={onClick}>
     <FaArrowRight />
   </div>
 );
 
   return (
     <main>
       <AppNavbar/>
       <Card className="text-white border-0" style={{borderRadius:'none'}}>
       <Card.Img src={homepage} alt="home-image" style={{minHeight:'620px',maxHeight:'750px'}}/>
       <Card.ImgOverlay className=' text-center align-items-center justify-content-around my-sm-3 py-lg-5 py-sm-3 '>
         <div className='mx-auto py-lg-5 my-lg-5 px-md-3 px-1 py-3 align-items-center justify-content-center' style={{background:'none', borderRadius:'none', maxWidth:'70rem'}}>
         <Card.Title className='px-lg-5 mx-lg-5 home-title' >Let Us Help You Find The Perfect Place to Go</Card.Title>
        
         <div className='mt-sm-5 pt-4'>
             <Form className='' noValidate validated={validated} onSubmit={handleSubmit}>
               <Row className='g-2 '>
                 <Col xs={12} sm={6} md={6} lg={3} style={{background:'#fff'}} className='mb-1 p-1 p-md-3'>
                  <Form.Group>
                   <Form.Label className='place d-flex align-items-start ps-2' style={{color: '#333',
 
 fontSize: '18px',
 fontFamily: 'Nunito',
 fontWeight: '700'}}>Where do you want to go?</Form.Label>
                 <Form.Control type="text" placeholder="State,Country,Zip, City" className='border-0' required/>
                 </Form.Group>
                 </Col>
                 <Col xs={12} sm={6} md={6} lg={3} style={{background:'#fff'}} className='mb-1 p-1 p-md-3'>
                  <Form.Group className=''>
                   <Form.Label className='place d-flex align-items-start ps-2' style={{color: '#333',
 
 fontSize: '18px',
 fontFamily: 'Nunito',
 fontWeight: '700'}}>Arrival</Form.Label>
                {/* <div className='custom-input-box'> <FaCalendar alt='calendar' className='calendar-icon d-flex d-sm-none'/>
                 <Form.Control type="date" name='place' placeholder='Choose a Date' className='border-0 custom-input' required/>
                 </div> */}
                 <div style={{width:'100%'}} className='d-flex'>
                 <DatePicker
            selected={selectedDate}
            onChange={handleDateChange}
            placeholderText="Choose a Date"
            className="border-0 p-2" // You can add your custom className here
            required
          />
          </div>
                 </Form.Group>
                 </Col >
                 <Col xs={12} sm={6} md={6} lg={3} style={{background:'#fff'}} className='mb-1 p-1 p-md-3'>
                  <Form.Group>
                   <Form.Label className='place d-flex align-items-start ps-2'style={{color: '#333',
 
 fontSize: '18px',
 fontFamily: 'Nunito',
 fontWeight: '700'}}>Departure</Form.Label>        
  <div style={{width:'100%'}} className='d-flex'>
                 <DatePicker
            selected={selectedDate2}
            onChange={handleDate2Change}
            placeholderText="Choose a Date"
            className="border-0 p-2" // You can add your custom className here
            required
          />
          </div>
                 </Form.Group>
                 </Col>
                 <Col xs={12} sm={6} md={6} lg={3} style={{background:'#fff'}} className='mb-1 p-1 p-md-3'>
                  <Form.Group>
                   <Form.Label className='place d-flex align-items-start ps-2'style={{color: '#333',
 
 fontSize: '18px',
 fontFamily: 'Nunito',
 fontWeight: '700'}}>Passengers</Form.Label>
                 <Form.Control type="text" placeholder="Number of passengers" className='border-0' required/>
                 </Form.Group>
                 </Col>
               </Row>
                 
               <Button type='submit'style={{
  width: '320px', height: '60px',
  
  borderRadius: '8px', border:'none',
  
  backgroundColor: '#008080'}} className='mt-md-5 mt-2'>Let's Go</Button>
             </Form>
             
         </div>
         </div>
       </Card.ImgOverlay>
     </Card>
    
     <Container fluid className='py-5 px-4 px-sm-5'>
 
    
            
   
 
       
       <section className="px-lg-5 mb-5 benefits">
         <Row className='px-xxl-5 '>
           <Col md={4} className='mb-3 d-block d-md-flex gap-2 align-items-center '>
             <img src={academiconsAfricarxiv} alt="icon" className="" style={{width:'50px', height:'50px'}} />
             <div className="flit mt-2">
               <h6 className="Swift">NO 1</h6>
               <p>Africa's leading travel agency</p>
             </div>
           </Col>
           <Col md={4} className='mb-3 d-block d-md-flex gap-2 align-items-center'>
             <img src={callcalling1} alt="icon" className="" style={{width:'50px', height:'50px'}} />
             <div className="flit mt-2">
               <h6 className="Swift">Availability</h6>
               <p>Our customer service team is available 24/7</p>
             </div>
           </Col>
           <Col md={4} className='mb-3 d-block d-md-flex gap-2 align-items-center'>
             <img src={safe} alt="icon" className="" style={{width:'50px', height:'50px'}}/>
             <div className="flit mt-2">
               <h6 className="Swift">Safe</h6>
               <p>Your safety is guaranteed with us</p>
             </div>
           </Col>
         </Row>
       </section>
       <section className="px-lg-5 mb-5">
         <h5 className="acc-section-header mb-4">Popular places to visit</h5>
         <Row xs={1} md={3} className='d-none d-md-flex'>
             <Col className='mb-3'>
             <Card>
       <Card.Img variant="top" src={palace} alt="palace-image" />
       <Card.Body className='gap-0'>
         <div className='d-flex align-items-center justify-content-between'>
         <Card.Title className='card-place' style={{fontWeight:'700'}}>Gyeongbok Palace</Card.Title>
         <img src={heart} alt='heart'/>
         </div>
         
         <Card.Text className='card-location'> Korea
         </Card.Text>
         <div className='d-flex align-items-center justify-content-between'>
           <div className='d-flex align-items-center gap-2'>
           <Button onClick={() => navigate('/signup')}style={{
  
  backgroundColor: '#008080'}} className=''>Learn more</Button>
         
           </div>
           <div className='d-flex gap-2'>
           <img src={star1} alt='star'/>
           <p className='my-auto'> 4.5  (56 Reviews)</p>
           </div>
         </div>
       </Card.Body>
     </Card>
             </Col >
             <Col className='mb-3'>
             <Card>
       <Card.Img variant="top" src={pyramid} alt="pyramid-image" />
       <Card.Body className='gap-0'>
         <div className='d-flex align-items-center justify-content-between'>
         <Card.Title className='card-place' style={{fontWeight:'700'}}>Pyramid of Egypt</Card.Title>
         <img src={heart} alt='heart'/>
         </div>
         
         <Card.Text className='card-location'> Egypt
         </Card.Text>
         <div className='d-flex align-items-center justify-content-between'>
           <div className='d-flex align-items-center gap-2'>
           <Button onClick={() => navigate('/signup')}style={{
  
  backgroundColor: '#008080'}} className=''>Learn more</Button>
         
           </div>
           <div className='d-flex gap-2'>
           <img src={star1} alt='star'/>
           <p className='my-auto'> 4.5  (56 Reviews)</p>
           </div>
         </div>
       </Card.Body>
     </Card>
             </Col>
             <Col className='mb-3'>
             <Card>
       <Card.Img variant="top" src={tower} alt="tower-image" />
       <Card.Body className='gap-0'>
         <div className='d-flex align-items-center justify-content-between'>
         <Card.Title className='card-place' style={{fontWeight:'700'}}>Great Tower</Card.Title>
         <img src={heart} alt='heart'/>
         </div>
         
         <Card.Text className='card-location'>Dubai
         </Card.Text>
         <div className='d-flex align-items-center justify-content-between'>
           <div className='d-flex align-items-center gap-2'>
           <Button onClick={() => navigate('/signup')}style={{
  
  backgroundColor: '#008080'}} className=''>Learn more</Button>
         
           </div>
           <div className='d-flex gap-2'>
           
           <img src={star1} alt='star'/>
           <p className='my-auto'> 4.5  (56 Reviews)</p>
          
           </div>
         </div>
       </Card.Body>
     </Card>
             </Col>
           </Row>
           <Carousel prevIcon={<CustomPrevIcon />} nextIcon={<CustomNextIcon />} className='d-flex d-md-none custom-carousel'  >
       <Carousel.Item interval={1000}>
       <Card>
       <Card.Img variant="top" src={palace} alt="palace-image" />
       <Card.Body className='gap-0'>
         <div className='d-flex align-items-center justify-content-between'>
         <Card.Title className='card-place' style={{fontWeight:'700'}}>Gyeongbok Palace</Card.Title>
         <img src={heart} alt='heart'/>
         </div>
         
         <Card.Text className='card-location'> Korea
         </Card.Text>
         <div className='d-flex align-items-center justify-content-between'>
           <div className='d-flex align-items-center gap-2'>
           <Button onClick={() => navigate('/signup')}style={{
  
  backgroundColor: '#008080'}} className=''>Learn more</Button>
         
           </div>
           <div className='d-flex gap-2'>
           <img src={star1} alt='star'/>
           <p className='my-auto'> 4.5  (56 Reviews)</p>
           </div>
         </div>
       </Card.Body>
     </Card>
       </Carousel.Item>
       <Carousel.Item interval={500}>
       <Card>
       <Card.Img variant="top" src={pyramid} alt="pyramid-image" />
       <Card.Body className='gap-0'>
         <div className='d-flex align-items-center justify-content-between'>
         <Card.Title className='card-place' style={{fontWeight:'700'}}>Pyramid of Egypt</Card.Title>
         <img src={heart} alt='heart'/>
         </div>
         
         <Card.Text className='card-location'> Egypt
         </Card.Text>
         <div className='d-flex align-items-center justify-content-between'>
           <div className='d-flex align-items-center gap-2'>
           <Button onClick={() => navigate('/signup')}style={{
  
  backgroundColor: '#008080'}} className=''>Learn more</Button>
       
           </div>
           <div className='d-flex gap-2'>
           <img src={star1} alt='star'/>
           <p className='my-auto'> 4.5  (56 Reviews)</p>
           </div>
         </div>
       </Card.Body>
     </Card>
       </Carousel.Item>
       <Carousel.Item>
       <Card>
       <Card.Img variant="top" src={tower} alt="tower-image" />
       <Card.Body className='gap-0'>
         <div className='d-flex align-items-center justify-content-between'>
         <Card.Title className='card-place' style={{fontWeight:'700'}}>Great Tower</Card.Title>
         <img src={heart} alt='heart'/>
         </div>
         
         <Card.Text className='card-location'>Dubai
         </Card.Text>
         <div className='d-flex align-items-center justify-content-between'>
           <div className='d-flex align-items-center gap-2'>
           <Button onClick={() => navigate('/signup')}style={{
  
  backgroundColor: '#008080'}} className=''>Learn more</Button>
         
           </div>
           <div className='d-flex gap-2'>
           
           <img src={star1} alt='star'/>
           <p className='my-auto'> 4.5  (56 Reviews)</p>
          
           </div>
         </div>
       </Card.Body>
     </Card>
       </Carousel.Item>
     </Carousel>
           <div className='forgot-password text-center justify-content-center mt-2'>
           <Link to="/gallery1" className='forgot-password' style={{fontSize:'20px'}}>View more</Link>
           </div>
        
 
     </section>
 
     <section className="px-lg-5 mb-5">
         <h2 className="acc-section-header mb-4">Today's Flight deals</h2>
         <Row xs={1} md={3} className='d-none d-md-flex'>
           <Col className='mb-3'>
             <img onClick={()=>navigate('/signup')} src={Group778} alt="palace-image"  style={{width:'100%'}}/>
           </Col>
 
           <Col className='mb-3'>
             <img onClick={()=>navigate('/signup')} src={Group779} alt="pyramid-image"  style={{width:'100%'}}/>
           </Col>
 
           <Col className='mb-3'>
             <img onClick={()=>navigate('/signup')} src={Group778} alt="tower-image" style={{width:'100%'}}/>
           </Col>
         
         </Row>
         <Carousel prevIcon={<CustomPrevIcon />} nextIcon={<CustomNextIcon />} className='d-flex d-md-none custom-carousel' >
       <Carousel.Item interval={1000}>
       <img onClick={()=>navigate('/signup')} src={Group778} alt="palace-image"  style={{width:'100%'}}/>
       </Carousel.Item>
       <Carousel.Item interval={500}>
       <img onClick={()=>navigate('/signup')} src={Group779} alt="pyramid-image"  style={{width:'100%'}}/>
       </Carousel.Item>
       <Carousel.Item>
       <img onClick={()=>navigate('/signup')} src={Group778} alt="tower-image" style={{width:'100%'}}/>
       </Carousel.Item>
     </Carousel>
         <div className='forgot-password text-center justify-content-center mt-2'>
           <Link to="/gallery2" className='forgot-password' style={{fontSize:'20px'}}>View more</Link>
           </div>
       </section>
       <section className="px-lg-5 mb-5 mb-md-0">
         <h2 className="acc-section-header mb-4">Rental services</h2>
       <Row className='gap-2'>
         <Col xs={12} md={6}>
           <img src={Group828} alt="vehicles-image" style={{width:'100%'}} />
         </Col>
 
         <Col className="">
           <div className='align-items-center justify-content-center my-lg-5 py-lg-5'>
           <p className='' style={{maxWidth:'525px', color: '#1E1E1E',
 fontSize: '22px',
 fontFamily: 'Nunito'}}>
           Improve your driving experience by selecting the appropriate rental to meet your needs. Our fleet includes a variety of sturdy, well-maintained vehicles in a range of sizes and brands.
           </p>
           <Button className="mt-2" onClick={()=> navigate('/signup')} style={{
     backgroundColor: '#008080', width:"200px", height:'40px', border:'none'}}>Rent a vehicle
           </Button>
           </div>
         </Col>
       </Row>
     </section>
 
 
     <section className="px-lg-5 mb-5 pb-md-5">
         <h2 className="acc-section-header mb-5 text-center" >Why Choose Us</h2>
       <section className='text-align-center justify-content-center text-center align-items-center'>
         <Row className="">
           <Col xs={12} md={6} lg={3} className="ave">
             <img src={ave} alt="icon" />
             <h5 className="my-3" style={{color: '#008080',
 fontSize: '28px',
 fontFamily: 'Nunito',
 fontWeight: '600'}}>Competitive Pricing</h5>
             <p style={{fontSize: '18px',
 fontFamily: 'Lora',
 fontWeight: '400'}}>We offer the best price across Africa and including local trips. </p>
           </Col>
           <Col xs={12} md={6} lg={3} className="aave">
             <img src={ave} alt="icon"  />
             <h5 className="my-3"style={{color: '#008080',
 fontSize: '28px',
 fontFamily: 'Nunito',
 fontWeight: '600'}}>Fast Booking</h5>
             <p style={{fontSize: '18px',
 fontFamily: 'Lora',
 fontWeight: '400'}}>Fast booking process with little and simple steps. </p>
           </Col>
           <Col xs={12} md={6} lg={3} className="aave">
             <img src={ave} alt="icon"  />
             <h5 className="my-3" style={{color: '#008080',
 fontSize: '28px',
 fontFamily: 'Nunito',
 fontWeight: '600'}}>Tour Guide</h5>
             <p style={{fontSize: '18px',
 fontFamily: 'Lora',
 fontWeight: '400'}}>We give you the perfect guide for your trip. </p>
           </Col>
           <Col xs={12} md={6} lg={3} className="aave">
             <img src={ave} alt="icon" />
             <h5 className="my-3" style={{color: '#008080',
 fontSize: '28px',
 fontFamily: 'Nunito',
 fontWeight: '600'}}>Discounts</h5>
             <p style={{fontSize: '18px',
 fontFamily: 'Lora',
 fontWeight: '400'}}>Mouth-watering discounts for all our services.</p>
           </Col>
         </Row>
       </section>
     </section>
 
     <section className="px-lg-5 mb-5">
         <h2 className="acc-section-header mb-5 text-center">What our customers say</h2>
          <div className=''>
         <Row className="gap-3 d-none d-lg-flex">
           <Col xs={12} lg={5} className="d-flex flex-column" style={{ height:'100%'}}>
             
           <div style={{ flex: '1' }}>
         <p style={{ fontSize: '20px', fontWeight: '400', height: '100%' }}>
           "I am a frequent traveler, and I have used this website to plan several trips over the years.
           I appreciate how user-friendly and comprehensive the site is, and the team behind it is always
           available to answer any questions or provide advice. Thanks to this website, I have been able to
           see some truly incredible places around the world."
         </p>
       </div>
             <div>
               <img src={sammy} alt="profile-img" width="62px" className="profile-img" />
               <div>
                 <p className="Swift">Sammy Jay.</p>
                 <p className="small">Nigeria</p>
               </div>
             </div>
           </Col>
           <Col xs={12} lg={5} className="d-flex flex-column" style={{ height:'100%'}}>
           <div style={{ flex: '1' }}>
         <p style={{ fontSize: '20px', fontWeight: '400', height: '100%' }}>
           "I was hesitant to book a trip during the pandemic, but this website provided me with all the information I needed
           to travel safely and responsibly. They had up-to-date information on travel restrictions and safety measures, and
           I was able to book a trip with confidence knowing that I had all the information I needed.
           Thanks for making my trip a success!"
         </p>
       </div>
             <div>
               <img src={princess} alt="profile-img" width="62px" className="profile-img" />
               <div>
                 <p className="Swift">Princess K.</p>
                 <p className="small">Ghana</p>
               </div>
             </div>
           </Col>
           <Col xs={12} xxl={true}className="justify-content-center align-items-center text-center py-2 py-xxl-5 ">
             
           <Link to="/signup" className='forgot-password' style={{fontSize:'24px'}}>Read more</Link>
             <FiArrowRight className="arrow-icon" style={{
     color: '#008080'}} />
 
             
           </Col>
         </Row>
         <div className='d-block d-lg-none'>
         <Carousel prevIcon={<CustomPrevIcon />} nextIcon={<CustomNextIcon />} className='mb-3 custom-carousel' >
       <Carousel.Item interval={1000}>
         <div className='p-2'>
         <div style={{ flex: '1' }}>
         <p style={{ fontSize: '20px', fontWeight: '400', height: '100%' }}>
           "I am a frequent traveler, and I have used this website to plan several trips over the years.
           I appreciate how user-friendly and comprehensive the site is, and the team behind it is always
           available to answer any questions or provide advice. Thanks to this website, I have been able to
           see some truly incredible places around the world."
         </p>
       </div>
             <div className='text-align-center text-center'>
               <img src={sammy} alt="profile-img" width="62px" className="profile-img" />
               <div>
                 <p className="Swift">Sammy Jay.</p>
                 <p className="small">Nigeria</p>
               </div>
             </div>
         </div>
       </Carousel.Item>
       <Carousel.Item >
      <div className='p-2'>
      <div style={{ flex: '1' }}>
         <p style={{ fontSize: '20px', fontWeight: '400', height: '100%' }}>
           "I was hesitant to book a trip during the pandemic, but this website provided me with all the information I needed
           to travel safely and responsibly. They had up-to-date information on travel restrictions and safety measures, and
           I was able to book a trip with confidence knowing that I had all the information I needed.
           Thanks for making my trip a success!"
         </p>
       </div>
             <div className='text-align-center text-center'>
               <img src={princess} alt="profile-img" width="62px" className="profile-img" />
               <div>
                 <p className="Swift">Princess K.</p>
                 <p className="small">Ghana</p>
               </div>
             </div>
      </div>
       </Carousel.Item>
    
     </Carousel>
     <div className="justify-content-center align-items-center text-center ">
             
             <Link to="/signup" className='forgot-password' style={{fontSize:'24px'}}>Read more</Link>
               <FiArrowRight className="arrow-icon" style={{
       color: '#008080'}} />
   
               
             </div>
           </div>
         </div>
       
     </section>
    </Container>
       
          <Card  className=" mb-3" style={{ width: '100%' , borderRadius:'none'}}>
             <Card.Img src={Footer} alt="Home" style={{ width: '100%', minHeight:'300px', maxHeight:'400px' }} />
             <Card.ImgOverlay style={{background:'none', borderRadius: 'none', maxWidth:'50rem'}}className='border-0 text-align-center text-center p-3 p-md-5 m-auto my-3 my-sm-5 '>
             <h3 className="welcome text-white  ">Do you want to stay updated with travel news?</h3>
     <p className="mt-4 text-center unsubscribe">Subscribe to our Newsletter</p>
     <div className=" ">
     <Form noValidate validated={validated} onSubmit={handleSubscribeSubmit}className='d-flex text-center gap-2 justify-content-center mt-3 '>
         <Form.Group >
           <Form.Control type='email' placeholder='Enter email address' className='py-2'required/>
         </Form.Group>
         <button type='submit' className='subscribe-button border-0'  style={{
     backgroundColor: '#008080'}}>Subscribe</button>
       </Form>
      
     </div>  
           
            </Card.ImgOverlay>
     
       </Card>
     
       <div className='chat-widget-container'>
           {!showChat && (
           <div className="chat-widget-icon" onClick={toggleChat}>
             <img src={chatIcon} alt='chatIcon'/>
           </div>
         )}
          
        {showChat && (
         <div>
           <div onClick={closeChat} className='close-chat'>
           <CloseButton variant="white"style={{position:'absolute'}} />
           </div>
           <Chatbot 
          
           config={config} messageParser={MessageParser} actionProvider={ActionProvider} closeChat={closeChat}
           />
         </div>
        )}
       
       </div>
     
 
     
       
 
  
     
 
       
 
   </main>
 
 
 
   );
 };


export default Home;
